import React from "react";
import {
    Card,
    CardHeader,
    Container,
    Row,
    Col,
    Button,
    InputGroup,
    InputGroupAddon,
    InputGroupText,
    Media,
    CardBody
} from "reactstrap";
import * as UnitHelper from "../../utils/UnitHelper";
import MessageBox from "./MessageBox";
import LoadingIndicator from ".//LoadingIndicator";
import ListService from "../../services/screens/admin/unittype/ListService";
import { withTranslation } from "react-i18next";
import UIDs from "../../UIDs";
import _ from 'lodash';

const uid = UIDs.components.ui.selectunittype;

class SelectUnitType extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            loading: true,
            unitTypeListById: null,
            unitTypeList: [],
        };
    }

    componentDidMount() {
        ListService.getAllUnitTypes((response) => {
            if (!this._umounted) {
                let unitTypeList = this.props.filter ? response.unitTypeList.filter(this.props.filter) : response.unitTypeList;
                this.setState({loading: false, unitTypeList: unitTypeList});
            }
        }, (error) => {
            if (!this._umounted) {
                MessageBox.danger({ text: error.message, duration: 300 });
            }
        });
    }

    componentWillUnmount() {
        this._umounted = true;
    }

    _handleSearch = (e) => {
        const id = e.target.value;
        const { unitTypeList } = this.state;
        let arr = [];
        let newUnitTypeList = _.clone(unitTypeList);
        for (let i = 0; i < newUnitTypeList.length; i++) {
            if (newUnitTypeList[i].id.indexOf(id.toUpperCase()) >= 0) {
                arr.push(newUnitTypeList[i]);
            }
        }

        if (id === "") {
            this.setState({unitTypeListById: null});
        }
        else {
            this.setState({unitTypeListById: arr});
        }
    };

    _renderLoading() {
        return (
            <Card className="shadow">
                <CardHeader className="bg-white border-0">
                    <Row className="align-items-center">
                        <Col xs="8">
                        </Col>
                        <Col className="text-right" xs="4">
                            <Button
                                color="default"
                                onClick={this.props.onCancel}
                                size="sm">
                                {this.props.t("cancel")}
                            </Button>
                        </Col>
                    </Row>
                </CardHeader>
                <CardBody>
                    <Row>
                        <div style={{ height: 200 }}>
                            <LoadingIndicator />
                        </div>
                    </Row>
                </CardBody>
            </Card>
        );
    }

    render() {
        const newUnitTypeList = this.state.loading ? null : UnitHelper.buildTypeList(this.state.unitTypeListById != null ? this.state.unitTypeListById : this.state.unitTypeList);
        return (
            <Row>
                <Col>
                    {newUnitTypeList ?
                     <Card className="shadow">
                         <CardHeader className="bg-white border-0">
                             <Row className="align-items-center">
                                 <Col xs="8">
                                     <InputGroup size="sm">
                                         <input className="form-control"
                                                ref="filterTemp"
                                                autoFocus={true}
                                                onKeyDown={(e) => {
                                                    if (e.keyCode == 13) {
                                                        // 禁止回车提交表单
                                                        e.preventDefault();
                                                        e.stopPropagation();
                                                    }
                                                }}
                                                onChange={(e) => this._handleSearch(e)}
                                                placeholder={this.props.t("filterTemp")} />
                                         <InputGroupAddon addonType="append">
                                             <InputGroupText><i className="fas fa-search" /></InputGroupText>
                                         </InputGroupAddon>
                                     </InputGroup>
                                 </Col>
                                 <Col className="text-right" xs="4">
                                     <Button
                                         color="default"
                                         onClick={this.props.onCancel}
                                         size="sm">
                                         {this.props.t("cancel")}
                                     </Button>
                                 </Col>
                             </Row>
                         </CardHeader>
                         <CardBody>
                             <Row>
                                 <div style={{ marginTop: "-15px" }}>
                                     {
                                         newUnitTypeList.map((item) => {
                                             return (
                                                 <div style={{ float: "left", marginTop: "8px", marginBottom: "8px", marginLeft: "8px" }}>
                                                     <Button
                                                         onClick={() => { this.props.onSelect(item) }}
                                                         style={{ paddingLeft: "13px", paddingRight: "13px", paddingTop: "10px", paddingBottom: "10px" }}
                                                     >
                                                         <Media>
                                                             <img src={item.imageUrl} alt="..." style={{ width: "110px", height: "190px" }} />
                                                         </Media>
                                                     </Button>
                                                     <div style={{ marginTop: "5px", textAlign: "center", fontSize: "12px" }}>{item.id + ":" + item.title}</div>
                                                 </div>
                                             );
                                         })
                                     }
                                 </div>
                             </Row>
                         </CardBody>
                     </Card> : this._renderLoading()
                    }
                </Col>
            </Row>
        );
    }
}

export default withTranslation(uid)(SelectUnitType);
